import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RegistrationService } from 'src/app/registration/registration.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { ConcessionManagementDataValidationForm } from '../../concession-registration.models';
import { DataConcessionScenario } from '../concession-basic-profile.component';
import { CommonService } from 'src/app/services/common.service';
import { OptionalDocumentsByCommodity } from 'src/app/interface/config.interface';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { FormatterData } from 'src/app/constants/app.constants';
import { LookupOptionsData } from 'src/app/jurisdiction/jurisdiction.domain';
import { AllDropdownKeys } from 'src/app/jurisdiction/jurisdiction.constants';
import { DateFormat } from 'src/app/domains/common.domain';
import { ConcessionRegistrationService } from '../../concession-registration.service';
import { ConcessionDataValidationFormUpdateModel } from '../data-concession-validation/data-concession-validation.component';

@Component({
  selector: 'app-concession-technician-data',
  templateUrl: './concession-technician-data.component.html',
  styleUrls: ['./concession-technician-data.component.scss'],
})
export class ConcessionTechnicianDataComponent extends DestroyableComponent implements OnInit {
  form: FormGroup = this.registrationService.technicianDataFG;

  isLoading: boolean;

  dataConcessionScenario: DataConcessionScenario = this.environmentService.dataForConcessionValidationScenario;
  optionalDocumentsByCommodity: OptionalDocumentsByCommodity[] = this.environmentService.optionalDocumentsByCommodity;
  showMastersExaminationOn: boolean = this.environmentService.showMastersExaminationOn;
  showTechnicianDataEmail: boolean = this.environmentService.showTechnicianDataEmail;
  allTitles: LookupOptionsData[] = this.commonService.getDropdownData(AllDropdownKeys.Title);
  titleKey: string = AllDropdownKeys.Title;
  dateFormat: DateFormat = FormatterData.date;
  optionalDocumentsTypes: Set<string> = new Set<string>();
  takeMandatoryDocumentsTypes: Set<string> = new Set<string>();
  specialistMandatoryDocumentsTypes: Set<string> = new Set<string>();
  allDocumentsResultingOfEmptyChecks: boolean;
  concessionManagementDataValidationForm: ConcessionManagementDataValidationForm;

  @Input() technicianId: string;
  @Input() showBdewId: boolean;
  @Input() autosave: boolean;
  @Input() updateOnConcessionValidationFormChange: boolean = true;

  private educationInformationDataFG = this.registrationService.educationInformationDataFG;
  private checkDataFG = this.registrationService.checkDataFG;

  constructor(
    private registrationService: RegistrationService,
    private environmentService: EnvironmentService,
    private commonService: CommonService,
    private concessionRegistrationService: ConcessionRegistrationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.preventLeak(this.concessionRegistrationService.concessionDataValidationFormUpdated$).subscribe(
      async (data: ConcessionDataValidationFormUpdateModel) => {
        this.concessionManagementDataValidationForm = data.formValue;

        if (data.preventUpdate || !this.updateOnConcessionValidationFormChange) return;

        await this.updateTechnician({ isFromAutosave: false });
      }
    );
  }

  async updateTechnician(options: { isFromAutosave: boolean }): Promise<void> {
    let technician = { ...this.form.value };
    if (this.concessionManagementDataValidationForm) {
      const dataConcession = {
        bdew_id: this.concessionManagementDataValidationForm.bdewTechnicianId,
        welding_license: this.concessionManagementDataValidationForm.hasWeldingLicense ? '1' : '0',
        concession_district_heating: this.concessionManagementDataValidationForm.isRegisterForDistrictHeating ? '1' : '0',
      };

      technician = { ...technician, ...dataConcession };

      if (this.dataConcessionScenario === 'Manual') {
        technician.role = this.concessionManagementDataValidationForm.role;
        technician.concession_district_heating = this.concessionManagementDataValidationForm.registeredCommodities?.heating ? '1' : '0';
      }

      technician.concession_gas = this.concessionManagementDataValidationForm.registeredCommodities?.gas ? '1' : '0';
      technician.concession_power = this.concessionManagementDataValidationForm.registeredCommodities?.power ? '1' : '0';
      technician.concession_water = this.concessionManagementDataValidationForm.registeredCommodities?.water ? '1' : '0';
    }

    if (technician.birthday) {
      const birthday = technician.birthday;
      technician.birthday = this.commonService.parseDateForSaving(birthday);
    }
    if (technician.qualification_issued_on) {
      const qualificationIssuedOn = technician.qualification_issued_on;
      technician.qualification_issued_on = this.commonService.parseDateForSaving(qualificationIssuedOn);
    }

    const checkData = this.checkDataFG.value;

    this.optionalDocumentsTypes.clear();

    if (this.optionalDocumentsByCommodity) {
      if (checkData.gas) {
        this.optionalDocumentsByCommodity
          .find(docs => docs.commodity === 'gas')
          .documents.forEach(doc => this.optionalDocumentsTypes.add(doc));
      }

      if (checkData.water) {
        this.optionalDocumentsByCommodity
          .find(docs => docs.commodity === 'water')
          .documents.forEach(doc => this.optionalDocumentsTypes.add(doc));
      }
    }

    this.addEducationInformationData(technician);
    const updateData = {
      technician: [technician],
    };

    if (!options.isFromAutosave || this.autosave) {
      await this.preventLeak(this.registrationService.updateTechnician(updateData, this.technicianId)).toPromise();
    }
  }

  private addEducationInformationData(technician: any): void {
    const educationInformationData = this.educationInformationDataFG.value;
    if (educationInformationData) {
      technician.education_information = educationInformationData;
    }
  }
}
